export interface DecodedTokenPayload {
    scope?: string;
    permissions?: string[];
    'wevo/org_roles'?: string[];
    [key: string]: unknown;
}

const ignoredScopePrefixes = ['openid', 'profile', 'email', 'offline_access', 'roles'];

export function extractPermissionsFromTokenPayload(decodedPayload: DecodedTokenPayload): string[] {
    if (Array.isArray(decodedPayload.permissions)) {
        return decodedPayload.permissions;
    }

    if (typeof decodedPayload.scope !== 'string') {
        return [];
    }

    return decodedPayload.scope
        .split(' ')
        .filter(
            (scope) =>
                scope.includes(':') &&
                !ignoredScopePrefixes.some((prefix) => scope.startsWith(prefix)),
        );
}

export function extractOrgRolesFromTokenPayload(decodedPayload: DecodedTokenPayload): string[] {
    return Array.isArray(decodedPayload['wevo/org_roles']) ? decodedPayload['wevo/org_roles'] : [];
}

export function shouldTreatPermissionsAsLoading({
    authLoading,
    isLoadingToken,
    isAuthenticated,
    permissionCount,
    hasGracePeriod,
}: {
    authLoading: boolean;
    isLoadingToken: boolean;
    isAuthenticated: boolean | undefined;
    permissionCount: number;
    hasGracePeriod: boolean;
}): boolean {
    return (
        authLoading ||
        isLoadingToken ||
        Boolean(isAuthenticated && permissionCount === 0 && hasGracePeriod)
    );
}
